import { Schema } from "effect";

export const DurableObjectClass = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^[A-Za-z_$][\w$]{0,63}$/)).pipe(Schema.brand("DurableObjectClass")))();
export type DurableObjectClass = typeof DurableObjectClass.Type;
export const DurableObjectInstance = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^[a-zA-Z0-9._:@-]{1,128}$/)).pipe(Schema.brand("DurableObjectInstance")))();
export type DurableObjectInstance = typeof DurableObjectInstance.Type;
export const DurableObjectFacet = /* @__PURE__ */ (() => Schema.String.check(Schema.isPattern(/^[a-zA-Z0-9._-]{1,64}$/)).pipe(Schema.brand("DurableObjectFacet")))();
export type DurableObjectFacet = typeof DurableObjectFacet.Type;
export const DurableObjectNamespaceInfo = /* @__PURE__ */ (() => Schema.StructWithRest(Schema.Struct({
  className: DurableObjectClass, firstSeen: Schema.Finite, lastSeen: Schema.Finite, source: Schema.Literals(["detect", "track", "manual"])
}), [Schema.Record(Schema.String, Schema.Json)]))();
export const DurableObjectInstanceInfo = /* @__PURE__ */ (() => Schema.StructWithRest(Schema.Struct({
  id: DurableObjectInstance, name: Schema.NullOr(Schema.String), firstSeen: Schema.Finite, lastSeen: Schema.Finite,
  via: Schema.Literals(["getByName", "get", "newUniqueId", "call", "manual"])
}), [Schema.Record(Schema.String, Schema.Json)]))();
export const DurableObjectFacetInfo = /* @__PURE__ */ (() => Schema.StructWithRest(Schema.Struct({
  name: DurableObjectFacet, lastSeen: Schema.Finite, isRoot: Schema.optionalKey(Schema.Boolean)
}), [Schema.Record(Schema.String, Schema.Json)]))();
export const DurableObjectResponses = /* @__PURE__ */ (() => ({
  namespaces: Schema.Struct({ namespaces: Schema.Array(DurableObjectNamespaceInfo) }),
  instances: Schema.Struct({ instances: Schema.Array(DurableObjectInstanceInfo) }),
  facets: Schema.Struct({ facets: Schema.Array(DurableObjectFacetInfo) }),
  instance: Schema.Struct({ ok: Schema.Literal(true), id: DurableObjectInstance })
}))();
